import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AuthLinkDirective } from './auth-link.directive';

@NgModule({
  declarations: [AuthLinkDirective],
  imports: [CommonModule],
  exports: [AuthLinkDirective],
})
export class AuthLinkModule {}
